import { Outlet } from "react-router-dom";
import HomeLayout from "./home.layout";
import PrivatePage from "./private.layout";

const Layout = () => {
  return (
    <PrivatePage>
      <section className="w-full h-full">
        <HomeLayout>
          <Outlet />
        </HomeLayout>
      </section>
    </PrivatePage>
  );
};

export default Layout;
